module.exports = __webpack_public_path__ + "img/Share of Search_old.c98573dd.svg";